import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

import LikeButton from '@components/like-button';
import ShareModal from '@components/modal/share-modal';
import Button from '@components/button';

import styles from './styles.module.scss';
const {
  close_button,
  modal,
  modal_inner,
  modal_overlay,
  modal_body_class,
  header,
  social_buttons,
  like_button,
  share_button,
  address
} = styles;

import Icon from '@components/icon';

const FullScreenModal = (props) => {
  const {
    children,
    content,
    contentLabel,
    onModalClose,
    onAfterOpen,
    onAfterClose,
    modalIsOpen,
    canonicalUrl,
    sharingServicesCollection,
    property
  } = props;

  const [shareModalIsOpen, setShareModalIsOpen] = useState(false);

  ReactModal.setAppElement('body');

  const overflowHidden = (modalIsOpen) => {
    if (modalIsOpen) {
      document.documentElement.style.overflow = 'hidden';
    } else {
      document.documentElement.style.removeProperty('overflow');
    }
  };

  useEffect((modalIsOpen) => {
    overflowHidden(modalIsOpen);
  }, []);

  return (
    <ReactModal
      isOpen={modalIsOpen}
      overlayClassName={modal_overlay}
      contentLabel={contentLabel}
      className={modal}
      onRequestClose={onModalClose}
      shouldReturnFocusAfterClose={false}
      bodyOpenClassName={modal_body_class}
      preventScroll={true}
      onModalClose={onModalClose}
      onAfterOpen={onAfterOpen}
      onAfterClose={onAfterClose}
    >
      <div className={header}>
        <button className={close_button} onClick={onModalClose}>
          <Icon type="arrow" name="medium-left" />
          <span>Return to listing</span>
        </button>
        <div className={address}>
          <p>{property.address}</p>
        </div>
        <div className={social_buttons}>
          <span className={like_button} role="button" tabIndex="0">
            <LikeButton header={true} id={property.listingId} />
          </span>
          <span className={share_button}>
            <Button
              icon="share"
              iconType="actions"
              label="Share"
              theme="text-only"
              onClick={() => setShareModalIsOpen(true)}
            />
          </span>
        </div>
      </div>
      <div className={modal_inner}>
        <div>{content || children}</div>
      </div>
      {shareModalIsOpen && (
        <ShareModal
          modalIsOpen={shareModalIsOpen}
          onModalClose={() => setShareModalIsOpen(false)}
          sharingServicesCollection={sharingServicesCollection}
          copyUrl={canonicalUrl}
        />
      )}
    </ReactModal>
  );
};

FullScreenModal.propTypes = {
  button: PropTypes.node,

  canonicalUrl: PropTypes.string,

  children: PropTypes.node,

  content: PropTypes.node,

  contentLabel: PropTypes.string,

  modalIsOpen: PropTypes.bool,

  onAfterClose: PropTypes.func,

  onAfterOpen: PropTypes.func,

  onModalClose: PropTypes.func,

  property: PropTypes.shape({
    address: PropTypes.string,
    images: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        url: PropTypes.string
      })
    ),
    listingId: PropTypes.number,
    listingUrl: PropTypes.string,
    status: PropTypes.arrayOf(
      PropTypes.shape({
        newConstruction: PropTypes.bool,
        newListing: PropTypes.bool,
        openHouse: PropTypes.bool,
        pending: PropTypes.bool,
        priceChange: PropTypes.bool
      })
    )
  }),

  sharingServicesCollection: PropTypes.arrayOf(
    PropTypes.shape({
      shareName: PropTypes.string,
      shareUrl: PropTypes.string
    })
  )
};

export default FullScreenModal;
